/* Relógio Militar Europeu — live-updating counter for the home
   section (partials/home/relogio-militar.hbs). Guarded on the
   counter element since this script runs on every page (concatenated
   into built/source.js) but the section only exists on the home. */
(function () {
    var counterEl = document.getElementById('relogioCounter');
    if (!counterEl) {
        return;
    }

    var ANNUAL_BUDGET_USD = 585000000000; // estimativa apenas-Europa da NATO, 2026 (ver metodologia)
    var BASE_YEAR = 2026;

    var UNIT_COST = {
        teacher: 57400,       // salário médio de professor na OCDE, USD PPC (Education at a Glance 2025)
        nurse: 48000,         // salário médio europeu estimado de enfermeiro, USD
        school: 27000000,     // nova escola secundária, referência europeia
        hospital: 1350000000  // novo hospital universitário, ex. CHU de Nantes
    };

    var yearStart = new Date(BASE_YEAR, 0, 1, 0, 0, 0);
    var yearEnd = new Date(BASE_YEAR + 1, 0, 1, 0, 0, 0);
    var totalMs = yearEnd - yearStart;
    var ratePerMs = ANNUAL_BUDGET_USD / totalMs;
    var ratePerSecond = ratePerMs * 1000;
    var ratePerDay = ratePerMs * 86400000;

    var el = {
        counter: counterEl,
        progressFill: document.getElementById('relogioProgressFill'),
        progressPct: document.getElementById('relogioProgressPct'),
        progressDays: document.getElementById('relogioProgressDays'),
        statPerSecond: document.getElementById('relogioStatPerSecond'),
        statPerDay: document.getElementById('relogioStatPerDay'),
        statElapsed: document.getElementById('relogioStatElapsed'),
        statAnnual: document.getElementById('relogioStatAnnual'),
        baseYearLabel: document.getElementById('relogioBaseYear'),
        yearTag: document.getElementById('relogioYearTag'),
        equivAmount: document.getElementById('relogioEquivAmount'),
        equivTeachers: document.getElementById('relogioEquivTeachers'),
        equivNurses: document.getElementById('relogioEquivNurses'),
        equivSchools: document.getElementById('relogioEquivSchools'),
        equivHospitals: document.getElementById('relogioEquivHospitals')
    };

    var usdWhole = new Intl.NumberFormat('pt-PT', {style: 'currency', currency: 'EUR', maximumFractionDigits: 0});
    var intWhole = new Intl.NumberFormat('pt-PT', {maximumFractionDigits: 0});
    var pct2 = new Intl.NumberFormat('pt-PT', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    var bn1 = new Intl.NumberFormat('pt-PT', {minimumFractionDigits: 1, maximumFractionDigits: 1});

    // "mil milhões" (bn) / "milhões" (M), standard Portuguese usage
    function formatScalePt(usd) {
        var abs = Math.abs(usd);
        if (abs >= 1e9) return bn1.format(usd / 1e9) + ' mil milhões €';
        if (abs >= 1e6) return bn1.format(usd / 1e6) + ' milhões €';
        return usdWhole.format(usd);
    }

    el.baseYearLabel.textContent = BASE_YEAR;
    el.yearTag.textContent = String(BASE_YEAR);
    el.statAnnual.textContent = formatScalePt(ANNUAL_BUDGET_USD);
    el.statPerSecond.textContent = usdWhole.format(ratePerSecond) + '/s';
    el.statPerDay.textContent = formatScalePt(ratePerDay) + '/dia';

    var totalDays = Math.round(totalMs / 86400000);

    function render() {
        var now = new Date();
        var elapsedMs = now - yearStart;
        if (elapsedMs < 0) elapsedMs = 0;
        if (elapsedMs > totalMs) elapsedMs = totalMs;

        var spent = elapsedMs * ratePerMs;
        el.counter.textContent = usdWhole.format(spent);

        el.equivAmount.textContent = formatScalePt(spent);
        el.equivTeachers.textContent = intWhole.format(Math.floor(spent / UNIT_COST.teacher));
        el.equivNurses.textContent = intWhole.format(Math.floor(spent / UNIT_COST.nurse));
        el.equivSchools.textContent = intWhole.format(Math.floor(spent / UNIT_COST.school));
        el.equivHospitals.textContent = intWhole.format(Math.floor(spent / UNIT_COST.hospital));

        var fraction = elapsedMs / totalMs;
        el.progressFill.style.width = (fraction * 100).toFixed(3) + '%';
        el.progressPct.textContent = pct2.format(fraction * 100) + '% do ano decorrido';

        var dayNum = Math.min(totalDays, Math.floor(elapsedMs / 86400000) + 1);
        el.progressDays.textContent = 'dia ' + dayNum + ' de ' + totalDays;

        var elapsedDays = Math.floor(elapsedMs / 86400000);
        var elapsedHours = Math.floor((elapsedMs % 86400000) / 3600000);
        el.statElapsed.textContent = elapsedDays + ' d ' + elapsedHours + ' h';
    }

    render();
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    setInterval(render, reduceMotion ? 1000 : 120);

    // Cycles the visible "Equivalente a" (.relogio-compact-equiv) between
    // the 4 equivalents every few seconds — each one's own number keeps
    // being updated live by render() above regardless of whether it's the
    // one currently shown, in its own (hidden, except for teachers') row
    // under .relogio-equiv-list.
    var activeNumEl = document.getElementById('relogioEquivActiveNum');
    var activeDescEl = document.getElementById('relogioEquivActiveDesc');

    if (activeNumEl && activeDescEl) {
        var equivRotation = [
            {id: 'relogioEquivTeachers', label: 'Professores de secundária'},
            {id: 'relogioEquivNurses', label: 'Enfermeiros'},
            {id: 'relogioEquivSchools', label: 'Escolas secundárias'},
            {id: 'relogioEquivHospitals', label: 'Hospitais universitários'}
        ];
        var equivIndex = 0;

        // Slot-machine scramble: the number stays put and rapidly cycles
        // random digits (same digit count/spacing as the real target text,
        // so it doesn't jump around) before settling on the real value.
        function scrambleNumber(finalText, duration) {
            var start = null;

            function frame(timestamp) {
                if (start === null) {
                    start = timestamp;
                }

                if (timestamp - start >= duration) {
                    activeNumEl.textContent = finalText;
                    return;
                }

                activeNumEl.textContent = finalText.replace(/[0-9]/g, function () {
                    return String(Math.floor(Math.random() * 10));
                });

                requestAnimationFrame(frame);
            }

            requestAnimationFrame(frame);
        }

        function rotateEquiv() {
            var item = equivRotation[equivIndex];
            var sourceEl = document.getElementById(item.id);
            var finalNum = sourceEl ? sourceEl.textContent : activeNumEl.textContent;

            if (reduceMotion) {
                activeDescEl.textContent = item.label;
                activeNumEl.textContent = finalNum;
            } else {
                scrambleNumber(finalNum, 500);

                // Fades out, swaps the text once invisible, fades back
                // in — the 250ms/250ms round trip roughly matches the
                // number's 500ms scramble, so both land together.
                activeDescEl.classList.add('is-fading');
                setTimeout(function () {
                    activeDescEl.textContent = item.label;
                    activeDescEl.classList.remove('is-fading');
                }, 250);
            }

            equivIndex = (equivIndex + 1) % equivRotation.length;
        }

        rotateEquiv();
        setInterval(rotateEquiv, reduceMotion ? 8000 : 4000);
    }
})();
